/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

/** @module components/brands-layout */
import baustein from "baustein";
import analytics from "../../analytics/analytics";
import globals from "../../modules/globals";

/**
 * Layout component for the brands page(s).
 */
export default baustein.register("brands-layout", {
    getInitialRenderContext() {
        return {
            brands_layout: {
                az_navigation: {
                    links: []
                },
                az_list: {
                    blocks: []
                }
            },
            banners: {}
        };
    },

    setupEvents(add) {
        add("click", ".az-block__items a", this.onItemClick);
    },

    /**
     * Tracks clicks on designer names.
     *
     * @params {Event} event
     */
    onItemClick(event) {
        event.preventDefault();
        let href = event.target.href;
        let trackingEventLabel = this._getTrackingEventLabel();

        if (event.metaKey) {
            // Doing this to avoid browser pop up blockers.
            analytics.event("navigation", "brands_page", trackingEventLabel);
            globals.window.open(href, "_blank");

            return;
        }

        analytics.event("navigation", "brands_page", trackingEventLabel).then(() => {
            globals.window.location = href;
        });
    },

    /**
     * Returns true if the page is the retailer page, otherwise false.
     *
     * @returns {Boolean}
     */
    _isStoresPage() {
        return this.options.brandsType === "stores";
    },

    _getTrackingEventLabel() {
        let eventLabel = "designer_name";

        if (this._isStoresPage()) {
            eventLabel = "store_name";
        }

        return eventLabel;
    }
});

